import { Checkbox, Dialog, MessageBar, MessageBarType, ProgressIndicator, Stack, Toggle } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { usePrivacy } from '../../hooks/usePrivacyHook';
import { isCanvasStudent, sendApiRequest, thisIsDevEnvironment } from '../../lib/helper';
import { useAuthenticationContext } from '../../providers/authenticationprovider';
import { HelperService } from '../../services/helperService';

const FRPAControl: React.FunctionComponent<{ onDismiss: () => void }> = ({ onDismiss }) => {

    const authenticationContext = useAuthenticationContext();
    const [isCurrentUserOptingOut, setIsConsentRejectedToggleOn] = useState<boolean>();
    const [successMessage, setSuccessMessage] = useState<string>();
    const [errorMessage, setErrorMessage] = useState<string>();
    const originalValue = usePrivacy()
    const [privacyStatement, setPrivacyStatement] = useState<string>();
    const [loadingPrivacyStatement, setLoadingPrivacyStatement] = useState<boolean>(true);

    useEffect(() => {
        setLoadingPrivacyStatement(true)
        HelperService.getKeplerEnvironmentVariable("REACT_APP_PRIVACY_STATEMENT", true).then((res: string | undefined) => {
            setPrivacyStatement(res);
            setLoadingPrivacyStatement(false)
        }).catch(err => {
            setErrorMessage(`Unable to load privacy statement`);
            console.error(err);
        });
    }, [authenticationContext.Result])

    useEffect(() => {
        const email = thisIsDevEnvironment ? authenticationContext.Result?.KeplerAuthStatus.account.username : authenticationContext.Result?.CanvasAuthStatus?.userEmail;
        if (email) {
            setSuccessMessage(undefined)
            setErrorMessage(undefined)
            if (isCurrentUserOptingOut !== undefined) {
                sendApiRequest(`/api/sql/updatePrivacySetting?isConsented=${isCurrentUserOptingOut}&userEmail=${email}`, "POST").then(() => {
                    setSuccessMessage(`Your permission to share were successfully saved`);
                }).catch(err => {
                    console.error(err);
                    setErrorMessage(`There was an error saving your permissions to share settings`);
                    setSuccessMessage(undefined);
                    setIsConsentRejectedToggleOn(originalValue)
                })
            }
        }
    }, [isCurrentUserOptingOut, authenticationContext?.Result?.UserInfo?.DisplayName, originalValue])

    //target only to students
    return !authenticationContext.Pending && authenticationContext.Result?.IsAuthenticated && (thisIsDevEnvironment || isCanvasStudent(authenticationContext.Result)) ? (
        <Dialog
            dialogContentProps={{
                title: "PERMISSION TO SHARE",
            }}
            minWidth={400}
            maxWidth={1280}
            onDismiss={onDismiss}
            hidden={false}>
            <Stack tokens={{ childrenGap: 20 }}>
                {loadingPrivacyStatement && <ProgressIndicator />}
                {privacyStatement && <div>{privacyStatement}</div>}
                {originalValue !== undefined && <Checkbox
                    label="MAKE MY WORK PRIVATE (HCAD recommends that you leave this box unchecked to facilitate shared learning experiences with your classmates.)"
                    defaultChecked={originalValue}
                    checked={isCurrentUserOptingOut === true ? true : (isCurrentUserOptingOut === false ? false : originalValue)}
                    onChange={(_ev, checked) => {
                        setIsConsentRejectedToggleOn(checked)
                    }} />
                }
                {errorMessage && <MessageBar messageBarType={MessageBarType.error}>{errorMessage}</MessageBar>}
                {successMessage && <MessageBar messageBarType={MessageBarType.success}>{successMessage}</MessageBar>}
            </Stack>
        </Dialog>
    ) : <></>;
}

export default FRPAControl;
